import angular from "angular";

angular.module('ui-sentinel.shipments.notificationsAdmin', [
    'api-sentinel'
]);
